import {
  getNextBonusTypeInOrder, getPlayerBonusConfig, PLAYER_BONUS_ORDER, PLAYER_BONUS_TYPES,
} from "../../configs/playerBonus";

/**
 * Уровни бонуса сетевого лобби — все уровни локальной игры, кроме «божества»:
 * его очки и кости задуманы для ботов божественной лиги и для локальных
 * партий, а бонус лобби достается всем игрокам сразу.
 */
export const LOBBY_BONUS_ORDER = PLAYER_BONUS_ORDER.filter((bonusType) => bonusType !== PLAYER_BONUS_TYPES.DIVINE);

export const checkIfLobbyBonusType = (value) => LOBBY_BONUS_ORDER.includes(value);

// Следующий уровень бонуса лобби по кругу
export const getNextLobbyBonusType = (bonusType) => getNextBonusTypeInOrder(LOBBY_BONUS_ORDER, bonusType);

/**
 * Бонус обычного сетевого лобби: один уровень на всех игроков лобби — и живых,
 * и ботов (в локальной игре бонус выбирается каждому игроку отдельно). Выбирает
 * создатель лобби до старта матча (SET_LOBBY_BONUS).
 *
 * В рейтинговых лобби бонуса нет: там экономический бонус — отличительная
 * черта «явных» ботов (см. configs/visibleRankedBots). Неизвестное значение —
 * тоже «нет».
 */
export const getLobbyBonusType = (lobby) => {
  if (!lobby || lobby.isRanked || !checkIfLobbyBonusType(lobby.bonusType)) {
    return PLAYER_BONUS_TYPES.NONE;
  }
  return lobby.bonusType;
};

/**
 * Поля бонуса лобби для игрока на старте матча — или null, если бонуса нет.
 * Числа фиксируются на старте (bonusConfig), как у «явных» ботов: правка
 * конфига не должна переписывать идущий матч, его запись и историю. Признак
 * hasLobbyBonus включает бонус в сетевой игре и в реплее (см.
 * checkIfPlayerBonusApplies).
 */
export const getLobbyBonusPlayerFields = (lobby) => {
  const bonusType = getLobbyBonusType(lobby);
  if (bonusType === PLAYER_BONUS_TYPES.NONE) {
    return null;
  }
  return {
    bonus: bonusType,
    bonusConfig: {...getPlayerBonusConfig(bonusType)},
    hasLobbyBonus: true,
  };
};
